import i18n from "i18n";
import { LECTUN_TYPE } from "views/Admin/Devices/ArcActivity";
import styles from "./ActionButtonsArc.module.scss";
import { useEffect } from "react";
import { capitalize } from "helpers/utils/utils_general";

export const ActionButtonsArc = ({
  cleanScrenn,
  handleBack,
  handleSubmit,
  groupedProducts,
  showView,
  typeLectun
}) => {
  const DISABLE_SUBMIT =
    (!groupedProducts.length && !showView.success) ||
    typeLectun === LECTUN_TYPE.AUTOMATIC;
  const DISABLE_BACK = !groupedProducts.length;

  // Ajusta el tamaño en base al tamaño de sidebar (expanded)
  useEffect(() => {
    const gridItemBottom = document.querySelector(".ActionButtonsArc");
    const sidebarComponent = document.querySelector(".sidebar-container");

    if (!gridItemBottom || !sidebarComponent) return;

    const updateLeftPosition = () => {
      gridItemBottom.style.left = `${sidebarComponent.clientWidth}px`;
      gridItemBottom.style.width = `calc(100% - ${sidebarComponent.clientWidth}px) `;
    };

    let debounceTimeout;

    const resizeObserver = new ResizeObserver(() => {
      clearTimeout(debounceTimeout);

      debounceTimeout = setTimeout(() => {
        updateLeftPosition();
      }, 0);
    });

    resizeObserver.observe(sidebarComponent);

    return () => {
      resizeObserver.disconnect();
      clearTimeout(debounceTimeout);
    };
  }, []);

  return (
    <footer className={styles["ActionButtonsArc"]}>
      <div>
        {!showView.success && (
          <button
            onClick={showView.confirmation ? handleBack : cleanScrenn}
            disabled={DISABLE_BACK}
          >
            {showView.confirmation ? i18n.t("go.back") : i18n.t("delete")}
          </button>
        )}
        <button
          onClick={handleSubmit}
          disabled={DISABLE_SUBMIT}
          className={showView.success ? styles["ActionButtonsArc__success-button"] : ""}
        >
          {showView.confirmation
            ? capitalize(i18n.t("finish"))
            : showView.success
            ? i18n.t("go.to.beginning")
            : showView.initial
            ? i18n.t("process")
            : ""}
        </button>
      </div>
    </footer>
  );
};
